import * as React from 'react';
import { IListItem, IMedicalRecord } from '@nkr/models/index';
import { PatientIntakeTabs } from './nav';

export interface IPatientIntakeContext {
    isAdminView: boolean,
    medicalRecordId: number,
    centerId: number,
    currentTab: PatientIntakeTabs,
    coordinatorList: IListItem[],
    referralStatusList: IListItem[],
    centerList: IListItem[],
    declineReasonList: IListItem[],
    ethnicityList: IListItem[],
    maritalStatusList: IListItem[],
    employmentStatusList: IListItem[],
    educationLevelList: IListItem[],
    stateList: IListItem[],
    primaryGoalList: IListItem[],
    registrationStatusList: IListItem[],
    showTransfer: boolean,
    onView: (medicalRecordId: number) => void,
    onSave: (data: IMedicalRecord, createRecipient: boolean, createMicrosite: boolean) => Promise<void>,
    onDownloadFile: (docType: number, lookupId: number) => Promise<any>,
    onGetQuestionaireReport: (lookupId: number) => Promise<any>,
    onPasswordResetEmail: (medicalRecordId: number) => Promise<any>,
    onUploadAboResults: (medicalRecordId: number, file: File) => Promise<any>,
    onCancelView: () => void,
    onToggleTransfer: (medicalRecordId: number, show: boolean) => void,
    onRefreshList: () => void
}

export const PatientIntakeContext = React.createContext<IPatientIntakeContext | null>(null);
export const PatientIntakeProvider = PatientIntakeContext.Provider;